import * as React from 'react'
import './SettlementFilters.scss'
import {connect} from "react-redux";
import {ActionType, settlementFilterType, storeType,} from "../../reducers/types";
import {Dispatch} from "redux";
import moment from "moment";
import 'react-dates/lib/css/_datepicker.css';
import {injectIntl, IntlShape} from 'react-intl'
import Grid from "@material-ui/core/Grid";
import Loadable from "react-loadable";

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    filters: settlementFilterType,
    handleFilterChange: (value: any) => void,
    onConfirm: () => void,
    onClear: () => void,
    onExport: () => void,
    intl: IntlShape
}

interface IState {
    focusedInput: string | null
}

const LoadableComponent = Loadable({
    loader: () => import('./SettlementDatePicker'),
    loading(){ return (<div>loading...</div>)},
});

class SettlementFillters extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            focusedInput: null
        }
    }

    handleDateChange = (value: any) => {
        let start = this.props.filters.startDate, end = this.props.filters.endDate
        if (value.startDate) {
            start = moment(value.startDate).format("YYYY-MM-DD")
        }
        if (value.endDate) {
            end = moment(value.endDate).format("YYYY-MM-DD")
        }
        this.props.handleFilterChange({...this.props.filters, startDate: start, endDate: end})
    }
    handleFocuseChange = (value: any) => {
        this.setState({focusedInput: value})
    }
    isOutsideRange = (day: any) => {
        return day.isAfter()
    }

    public render() {
        let {filters, intl} = this.props
        return (
            <div className="settlementFilters">
                <Grid container spacing={2} alignItems='flex-end'>
                    <Grid item className="filterItem">
                        <LoadableComponent filters={filters}
                                           handleDateChange={this.handleDateChange}
                                           focusedInput={this.state.focusedInput}
                                           handleFocuseChange={this.handleFocuseChange}/>
                    </Grid>
                    <Grid item>
                        <button className="op-button primaryButton"
                                onClick={this.props.onConfirm}>{intl.formatMessage({id: 'query'})}</button>
                        <button className="op-button whiteButton"
                                onClick={this.props.onExport}>{intl.formatMessage({id: 'export'})}</button>
                        <button className="op-button whiteButton"
                                onClick={this.props.onClear}>{intl.formatMessage({id: 'clear'})}</button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default injectIntl(connect((state: storeType) => {
    return {}
})(SettlementFillters))
